exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".bezel[data-v-390f52a6]{display:flex;flex-direction:row;flex-wrap:wrap}.bezel-box[data-v-390f52a6]{min-width:188px;margin-right:20px;margin-bottom:20px;border:1px solid #bfcbd9;border-radius:10px;display:flex;flex-direction:column;align-items:center}.bezel-close[data-v-390f52a6]{width:44px;height:34px;margin-top:-17px;margin-right:-20px;align-self:flex-end;background-color:hsla(0,0%,100%,0);border-color:hsla(0,0%,100%,0)}.bezel-input[data-v-390f52a6]{width:148px}.bezel-item[data-v-390f52a6]{margin-top:10px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-rewriter.js?id=data-v-390f52a6&scoped=true!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/views/OperationManage/UserAdminister/PersonalizedPart/Components/EmojiPack.vue
// module id = 495
// module chunks = 0